import React, { useState, useEffect } from 'react'

import {
	Button,
	Container,
	Icon,
	IconButton,
	InputAdornment,
	Typography,
	TextField,
	Toolbar
} from '@material-ui/core'

import { AddOutlined } from '@material-ui/icons'

import { makeStyles, useTheme } from '@material-ui/core/styles'

import { useSelector } from 'react-redux'

import PetCard from '../../../components/Cards/Pets/PetCard'
import clsx from 'clsx'
import { useHistory } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
	container: {
		padding: '24px'
	},
	toolbar: {
		marginBottom: 24,
		backgroundColor: 'transparent'
	},
	searchField: {
		minWidth: 350,
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		paddingLeft: theme.spacing(2),
		'& .MuiFilledInput-input': {
			padding: '5px 12px 4px'
		},
		'& .MuiInputAdornment-positionStart': {
			marginRight: 0
		}
	},
	iconButton: {
		padding: 0
	},
	icon: {
		display: 'flex',
		justifyContent: 'center',
		'&::before': {
			fontSize: '16px',
			color: '#777679',
			lineHeight: '27px'
		}
	},
	headerButton: {
		fontFamily: 'Nunito',
		fontWeight: '700',
		marginLeft: 16,
		'& .MuiButton-label': {
			lineHeight: '19px',
			fontSize: '14px'
		}
	},
	addButton: {
		color: theme.palette.secondary.main,
		borderColor: theme.palette.secondary.main,
		padding: '7px 40px 8px 24px',
		'& .MuiButton-label': {
			'& .MuiButton-startIcon': {
				marginRight: 16
			}
		},
		'&.Mui-disabled .MuiButton-label .MuiButton-startIcon .MuiSvgIcon-root': {
			fill: 'rgba(0, 0, 0, 0.12) !important'
		}
	}
}))

const Pets = (props) => {
	const classes = useStyles()
	const theme = useTheme()
	const history = useHistory()
	const client = useSelector((state) => state.specific.households.selected)
	const [search, setSearch] = useState('')
	const [filteredPets, setFilteredPets] = useState([])

	useEffect(() => {
		if (client && client.pets.length) {
			setFilteredPets(client.pets)
		}
	}, [client])

	useEffect(() => {
		if (search) {
			setFilteredPets(
				client.pets.filter(
					(pet) =>
						pet.name.includes(search) ||
						(pet.breed && pet.breed.includes(search)) ||
						(pet.age && pet.age.includes(search)) ||
						(pet.color && pet.color.includes(search)) ||
						(pet.characteristics &&
							pet.characteristics.some((characteristic) => characteristic.includes(search)))
				)
			)
		} else if (client && !search) {
			setFilteredPets(client.pets)
		}
	}, [search])

	const goToAddPetPage = () => {
		if (client) {
			history.push(`/clients/${client._id}/pets/add`)
		}
	}

	return (
		<div>
			<Container className={classes.container} maxWidth={false}>
				<Toolbar className={classes.toolbar}>
					<Typography variant="h6">Pets</Typography>
					<TextField
						value={search}
						onChange={(e) => setSearch(e.target.value)}
						className={classes.searchField}
						variant="filled"
						placeholder="Search..."
						InputProps={{
							startAdornment: (
								<InputAdornment position="start" style={{ paddingLeft: '12px' }}>
									<Icon fontSize="small" className={clsx(['fas fa-search', classes.icon])} />
								</InputAdornment>
							),
							endAdornment: search ? (
								<InputAdornment position="end">
									<IconButton
										disabled={!search}
										onClick={() => setSearch('')}
										className={classes.iconButton}>
										<Icon className={clsx(['fas fa-times', classes.icon])} />
									</IconButton>
								</InputAdornment>
							) : null
						}}
					/>
					<Button
						variant="outlined"
						className={clsx(classes.headerButton, classes.addButton)}
						startIcon={<AddOutlined style={{ fill: theme.palette.secondary.main }} />}
						size="large"
						onClick={() => goToAddPetPage()}>
						{filteredPets && filteredPets.length ? 'Another Pet' : 'Pet'}
					</Button>
				</Toolbar>
				{filteredPets && filteredPets.length
					? filteredPets.map((pet) => <PetCard key={pet._id} pet={pet} />)
					: null}
			</Container>
		</div>
	)
}

export default Pets
